import produce from 'immer';
import { Reducer } from 'redux';

import {
  IUserState,
  IUsersActionsType,
  IUsersTypes,
  ChangePasswordStatus,
} from './types';

const INITIAL_STATE: IUserState = {
  loading: false,
  loadingActivation: false,
  loadingGroupsOrProfile: false,
  loadingUsersByGroups: false,
  loadingActiveUsers: false,
  users: [],
  user: undefined,
  pagecount: 0,
  total: 0,
  groups: [],
  userProfile: undefined,
  changePasswordError: undefined,
  profiles: [],
  camundaUsers: [],
  activatedUsers: [],
  usersByGroups: [],
  changePasswordStatus: ChangePasswordStatus.REQUEST,
};

const user: Reducer<IUserState, IUsersActionsType> = (
  state = INITIAL_STATE,
  action: IUsersActionsType,
) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case IUsersTypes.GET_USERS_REQUEST: {
        draft.loading = true;
        break;
      }
      case IUsersTypes.GET_USERS_SUCCESS: {
        draft.loading = false;
        draft.users = action.payload.users;
        draft.pagecount = Number(action.payload.pagecount);
        draft.total = Number(action.payload.total);
        break;
      }
      case IUsersTypes.GET_USERS_FAILURE: {
        draft.loading = false;
        break;
      }

      case IUsersTypes.GET_USER_BY_APPLICATION_ID_AND_EMAIL_REQUEST: {
        draft.loading = true;
        draft.user = undefined;
        break;
      }
      case IUsersTypes.GET_USER_BY_APPLICATION_ID_AND_EMAIL_SUCCESS: {
        draft.loading = false;
        draft.user = action.payload.user;
        break;
      }
      case IUsersTypes.GET_USER_BY_APPLICATION_ID_AND_EMAIL_FAILURE: {
        draft.loading = false;
        draft.user = undefined;

        break;
      }

      case IUsersTypes.ADD_USER_REQUEST: {
        draft.loading = true;
        break;
      }
      case IUsersTypes.ADD_USER_SUCCESS: {
        draft.loading = false;
        break;
      }
      case IUsersTypes.ADD_USER_FAILURE: {
        draft.loading = false;
        break;
      }

      case IUsersTypes.CHANGE_USER_PASSWORD_REQUEST: {
        draft.loading = true;
        draft.changePasswordError = undefined;
        break;
      }
      case IUsersTypes.CHANGE_USER_PASSWORD_SUCCESS: {
        draft.loading = false;
        draft.changePasswordError = false;
        draft.changePasswordStatus = ChangePasswordStatus.SUCCESS;
        break;
      }
      case IUsersTypes.CHANGE_USER_PASSWORD_FAILURE: {
        draft.loading = false;
        draft.changePasswordError = true;
        break;
      }
      case IUsersTypes.CHANGE_USER_PASSWORD_RESET_REQUEST: {
        draft.changePasswordError = undefined;
        break;
      }

      case IUsersTypes.ACTIVATE_USER_REQUEST: {
        draft.loadingActivation = true;
        break;
      }
      case IUsersTypes.ACTIVATE_USER_SUCCESS: {
        draft.loadingActivation = false;
        const userIndex = draft.users.findIndex(
          (user) => user.id === action.payload.user_id,
        );
        draft.users[userIndex].activated = action.payload.activate;
        break;
      }
      case IUsersTypes.ACTIVATE_USER_FAILURE: {
        draft.loadingActivation = false;
        break;
      }

      case IUsersTypes.GET_GROUPS_REQUEST: {
        draft.loadingGroupsOrProfile = true;
        break;
      }
      case IUsersTypes.GET_GROUPS_SUCCESS: {
        draft.loadingGroupsOrProfile = false;
        draft.groups = action.payload.groups;
        break;
      }
      case IUsersTypes.GET_GROUPS_FAILURE: {
        draft.loadingGroupsOrProfile = false;
        break;
      }

      case IUsersTypes.GET_USER_GROUPS_REQUEST: {
        draft.loadingGroupsOrProfile = true;
        break;
      }
      case IUsersTypes.GET_USER_GROUPS_SUCCESS: {
        draft.loadingGroupsOrProfile = false;
        const userIndex = draft.users.findIndex(
          (user) => user.id === action.payload.user_id,
        );
        draft.users[userIndex].groups = action.payload.groups;
        break;
      }
      case IUsersTypes.GET_USER_GROUPS_FAILURE: {
        draft.loadingGroupsOrProfile = false;
        break;
      }

      case IUsersTypes.ADD_USER_GROUP_REQUEST: {
        draft.loadingGroupsOrProfile = true;
        break;
      }
      case IUsersTypes.ADD_USER_GROUP_SUCCESS: {
        draft.loadingGroupsOrProfile = false;
        const userIndex = draft.users.findIndex(
          (user) => user.id === action.payload.user_id,
        );
        draft.users[userIndex].groups.push(action.payload.group);
        break;
      }
      case IUsersTypes.ADD_USER_GROUP_FAILURE: {
        draft.loadingGroupsOrProfile = false;
        break;
      }

      case IUsersTypes.REMOVE_USER_GROUP_REQUEST: {
        draft.loadingGroupsOrProfile = true;
        break;
      }
      case IUsersTypes.REMOVE_USER_GROUP_SUCCESS: {
        draft.loadingGroupsOrProfile = false;
        const userIndex = draft.users.findIndex(
          (user) => user.id === action.payload.user_id,
        );
        const filteredGroups = draft.users[userIndex].groups.filter(
          (group) => group.id !== action.payload.group.id,
        );
        draft.users[userIndex].groups = filteredGroups;
        break;
      }
      case IUsersTypes.REMOVE_USER_GROUP_FAILURE: {
        draft.loadingGroupsOrProfile = false;
        break;
      }

      case IUsersTypes.GET_PROFILES_REQUEST: {
        draft.loadingGroupsOrProfile = true;
        break;
      }
      case IUsersTypes.GET_PROFILES_SUCCESS: {
        draft.loadingGroupsOrProfile = false;
        draft.profiles = action.payload.profiles;
        break;
      }
      case IUsersTypes.GET_PROFILES_FAILURE: {
        draft.loadingGroupsOrProfile = false;
        break;
      }

      case IUsersTypes.GET_USER_PROFILE_REQUEST: {
        draft.loadingGroupsOrProfile = true;
        break;
      }
      case IUsersTypes.GET_USER_PROFILE_SUCCESS: {
        draft.loadingGroupsOrProfile = false;

        draft.userProfile = action.payload.userProfile;

        break;
      }
      case IUsersTypes.GET_USER_PROFILE_FAILURE: {
        draft.loadingGroupsOrProfile = false;
        break;
      }

      case IUsersTypes.GET_USER_PROFILES_REQUEST: {
        draft.loadingGroupsOrProfile = true;
        break;
      }
      case IUsersTypes.GET_USER_PROFILES_SUCCESS: {
        draft.loadingGroupsOrProfile = false;
        const userIndex = draft.users.findIndex(
          (user) => user.id === action.payload.user_id,
        );
        draft.users[userIndex].profiles = action.payload.profiles;
        break;
      }
      case IUsersTypes.GET_USER_PROFILES_FAILURE: {
        draft.loadingGroupsOrProfile = false;
        break;
      }

      case IUsersTypes.ADD_USER_PROFILE_REQUEST: {
        draft.loadingGroupsOrProfile = true;
        break;
      }
      case IUsersTypes.ADD_USER_PROFILE_SUCCESS: {
        draft.loadingGroupsOrProfile = false;
        const userIndex = draft.users.findIndex(
          (user) => user.id === action.payload.user_id,
        );
        draft.users[userIndex].profiles.push(action.payload.profile);
        break;
      }
      case IUsersTypes.ADD_USER_PROFILE_FAILURE: {
        draft.loadingGroupsOrProfile = false;
        break;
      }

      case IUsersTypes.UPDATE_USER_PROFILE_REQUEST: {
        draft.loadingGroupsOrProfile = true;

        break;
      }
      case IUsersTypes.UPDATE_USER_PROFILE_SUCCESS: {
        draft.loadingGroupsOrProfile = false;

        const newProfileCredentials = action.payload.userProfile;

        draft.userProfile = newProfileCredentials;

        break;
      }
      case IUsersTypes.UPDATE_USER_PROFILE_FAILURE: {
        draft.loadingGroupsOrProfile = false;
        break;
      }

      case IUsersTypes.REMOVE_USER_PROFILE_REQUEST: {
        draft.loadingGroupsOrProfile = true;
        break;
      }
      case IUsersTypes.REMOVE_USER_PROFILE_SUCCESS: {
        draft.loadingGroupsOrProfile = false;
        const userIndex = draft.users.findIndex(
          (user) => user.id === action.payload.user_id,
        );
        const filteredProfiles = draft.users[userIndex].profiles.filter(
          (profile) => profile.id !== action.payload.profile.id,
        );
        draft.users[userIndex].profiles = filteredProfiles;
        break;
      }
      case IUsersTypes.REMOVE_USER_PROFILE_FAILURE: {
        draft.loadingGroupsOrProfile = false;
        break;
      }

      case IUsersTypes.GET_CAMUNDA_USERS_REQUEST: {
        break;
      }
      case IUsersTypes.GET_CAMUNDA_USERS_SUCCESS: {
        draft.camundaUsers = action.payload.camundaUsers;
        break;
      }
      case IUsersTypes.GET_CAMUNDA_USERS_FAILURE: {
        break;
      }

      case IUsersTypes.GET_ACTIVATED_USERS_REQUEST: {
        draft.loadingActiveUsers = true;
        break;
      }
      case IUsersTypes.GET_ACTIVATED_USERS_SUCCESS: {
        draft.loadingActiveUsers = false;
        draft.activatedUsers = action.payload.activatedUsers;
        break;
      }
      case IUsersTypes.GET_ACTIVATED_USERS_FAILURE: {
        draft.loadingActiveUsers = false;
        break;
      }

      case IUsersTypes.GET_USERS_BY_GROUPS_REQUEST: {
        draft.loadingUsersByGroups = true;
        draft.usersByGroups = [];
        break;
      }
      case IUsersTypes.GET_USERS_BY_GROUPS_SUCCESS: {
        draft.loadingUsersByGroups = false;
        draft.usersByGroups = action.payload.usersByGroups;
        break;
      }
      case IUsersTypes.GET_USERS_BY_GROUPS_FAILURE: {
        draft.loadingUsersByGroups = false;
        break;
      }

      default:
    }
  });
};
export default user;
